import { getOptionalAndCannedQuestions } from '../../../containers/checkout/utils';
import { CheckoutState } from '../../../state';
import { getQuestionsForBuyer } from './getQuestionsForBuyer';

/**
 * @private Do not use this directly, derive information from `getSurvey` instead
 */
export const getCannedAndOptionalQuestionsForBuyer = (state: CheckoutState) =>
    getOptionalAndCannedQuestions(getQuestionsForBuyer(state));
